import { CadastralAndDirectionModel } from './cadastral-and-direction.model';
export interface CadastralResponse {
  cadastralReferenceAndDirection: CadastralAndDirectionModel[];
  errorString: string;
}
